
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 20 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.33268 1.66699C2.41221 1.66699 1.66602 2.41318 1.66602 3.33366V16.667C1.66602 17.5875 2.41221 18.3337 3.33268 18.3337H16.666C17.5865 18.3337 18.3327 17.5875 18.3327 16.667V3.33366C18.3327 2.41318 17.5865 1.66699 16.666 1.66699H3.33268ZM5 5H15V6.66667H5V5ZM5 11.6667H13.3333V13.3333H5V11.6667ZM10.8333 8.33333H5V10H10.8333V8.33333Z","fill":"currentColor"}})])
          )
        }
      }
    